function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Brand / Medium / Money / Change"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape"
}, /*#__PURE__*/React.createElement("g", {
  id: "mask 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.6395 1.06066L23.7002 0L26.8822 3.18198L23.7002 6.36396L22.6395 5.3033L24.7609 3.18198L22.6395 1.06066ZM26.7428 42.7607L24.6214 44.882L26.7428 47.0033L25.6821 48.064L22.5001 44.882L25.6821 41.7L26.7428 42.7607ZM2.78041 31.5H4.379C6.87752 38.0326 12.5446 42.9982 19.5001 44.5167V46.0499C11.7112 44.4688 5.38329 38.8642 2.78041 31.5ZM1.9502 19.5C3.73977 10.6839 10.684 3.73965 19.5001 1.95008V3.48327C11.5143 5.22677 5.22689 11.5142 3.48338 19.5H1.9502ZM30.0001 45.6912V44.1304C38.6746 41.5487 45.0001 33.5131 45.0001 24C45.0001 14.4869 38.6746 6.45128 30.0001 3.86964V2.30885C39.5137 4.93458 46.5001 13.6514 46.5001 24C46.5001 34.3486 39.5137 43.0654 30.0001 45.6912Z",
  fill: "#616161",
  id: "Vector"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Detail"
}, /*#__PURE__*/React.createElement("g", {
  id: "mask 4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 29.932C22.2883 29.6173 21 28.246 21 26.5979H22.773C22.773 27.5903 23.6575 28.3914 24.75 28.3914C25.8398 28.3914 26.727 27.5865 26.727 26.5979C26.727 25.7386 26.1222 25.2506 24.4731 24.764C22.2861 24.1117 21 23.1024 21 21.4021C21 19.754 22.2883 18.3827 24 18.068V16.5H25.5V18.0682C27.2104 18.384 28.5 19.7581 28.5 21.4021H26.727C26.727 20.4135 25.8398 19.6086 24.75 19.6086C23.6575 19.6086 22.773 20.4097 22.773 21.4021C22.773 22.217 23.4856 22.7762 25.0242 23.2351C27.3173 23.9117 28.5 24.8661 28.5 26.5979C28.5 28.2419 27.2104 29.616 25.5 29.9318V31.5H24V29.932ZM1.5 22.5H7.5V28.5H1.5V22.5Z",
  fill: "#FF5630",
  id: "Vector_2"
}))));

var SvgOrderedIcon = function SvgOrderedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 49,
    viewBox: "0 0 48 49",
    width: 48,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrderedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ordered-icon.f72dd7a8.svg";
export { ForwardRef as ReactComponent };